// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operator-reject-reasons-chart {
  width: 100%;
  min-width: 0;
}

.operator-reject-tooltip {
  min-width: 170px;
  padding: 11px 13px;
  color: #334155;
  font-family: inherit;
  font-size: 11px;
}
.operator-reject-tooltip strong,
.operator-reject-tooltip span {
  display: block;
}
.operator-reject-tooltip strong {
  color: #0f172a;
}
.operator-reject-tooltip span {
  margin: 2px 0 8px;
  color: #ef4444;
  font-size: 9px;
  font-weight: 700;
}
.operator-reject-tooltip div {
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/Dashboard/operator-utilization/components/OperatorRejectReasonsChart.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;AACF;AACE;;EAEE,cAAA;AACJ;AAEE;EACE,cAAA;AAAJ;AAGE;EACE,iBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AADJ;AAIE;EACE,eAAA;AAFJ","sourcesContent":[".operator-reject-reasons-chart {\n  width: 100%;\n  min-width: 0;\n}\n\n.operator-reject-tooltip {\n  min-width: 170px;\n  padding: 11px 13px;\n  color: #334155;\n  font-family: inherit;\n  font-size: 11px;\n\n  strong,\n  span {\n    display: block;\n  }\n\n  strong {\n    color: #0f172a;\n  }\n\n  span {\n    margin: 2px 0 8px;\n    color: #ef4444;\n    font-size: 9px;\n    font-weight: 700;\n  }\n\n  div {\n    margin-top: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
